"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FileSelectionFilter;
(function (FileSelectionFilter) {
    FileSelectionFilter[FileSelectionFilter["None"] = 0] = "None";
    FileSelectionFilter[FileSelectionFilter["Images"] = 1] = "Images";
})(FileSelectionFilter || (FileSelectionFilter = {}));
exports.default = FileSelectionFilter;
//# sourceMappingURL=FileSelectionFilter.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/data/owa-fileprovider-store/lib/store/schema/FileSelectionFilter.js
// module id = 1805
// module chunks = 2 3 40 106 107